import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class SettingsAPIService {
  private readonly controller = 'settings';

  constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  public GetPortalApiSyncVersion() {
    const request = 'getAppVersion';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.getRaw(url);
  }

  public GetTenantApiSyncVersion() {
    const request = 'getAppVersion';
    const url = this._apiService.buildUrl(
      this._envConfig.TENANT_BACKEND_APISYNC_URL.replace('/tap', ''),
      this.controller,
      request
    );

    return this._apiService.getRaw(url);
  }
}
